import { Component, HostListener, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Subscription, take } from "rxjs";
import {
  ActionLog,
  ActionLogActionLevel,
  ActionLogsDataI,
} from "src/app/core/models/actionLog";
import { ActionLogService } from "src/app/core/services/action-log.service";
import { AuthenticationService } from "src/app/core/services/authentication.service";
import { NavigationService } from "src/app/core/services/navigation.service";
import * as XLSX from "xlsx";
import { EnvironmentService } from "src/app/core/services/environment.service";
import { UserRoleNames } from "../../../../core/models/users";
import { ConfirmDialogComponent } from "src/app/modules/shared/components/confirm-dialog/confirm-dialog.component";
import { Entities } from "src/app/core/models/globals";
import { ConfigEntityService } from "src/app/core/services/config-entity.service";

@Component({
  selector: "app-action-logs",
  templateUrl: "./action-logs.component.html",
  styleUrls: ["./action-logs.component.scss"],
})
export class ActionLogsComponent implements OnInit {
  selectedDataType: string; // Default selection
  filterText: string = "";
  filteredActionLogs: any[] = [];
  depName: string;
  currentLoggedUser: string;
  currentUserRole = this.authenticationService.getRole();
  actionLogs: ActionLog[] = [];
  actionLogsCopy: ActionLog[] = [];
  actionLogsToDownload: ActionLog[] = [];
  allActionTypes = [];
  allActionLevels = [];
  allInitiators = [];
  p: number = 1;
  dataAvailable: boolean;
  loadActionLogDataSub: Subscription;
  sortDate = 0;
  selectAll = false;
  defaultValueOfEntry = this.env.envVariables.logsPerRequestCount;
  entries = this.defaultValueOfEntry;
  logNumberEntries: number[] = [];
  totalLogsCount: number;
  showDelete: boolean = true;
  logsNumberToShow: number = 20;
  entriesNumber: number = 20;
  showAllEntries: boolean = false;
  actionPaths: string[] = [];
  actionEntityName: string = "all";
  entityNames: string[] = [];
  // variables to store current filter
  actionFilterValue = "all";
  actionLevelFilterValue: number = 10; // 10 represents all
  initiatorFilterValue = "all";
  actionPathFilterValue: string = "all";
  entityFilterValue = "Deployment";
  selectedActionLogs = [];
  shouldShowColumn = false;
  columnName = "";
  toShowFilter = false;
  currentActiveEntityConfigurator: boolean =
    this.navService.getCurrentEntity() == Entities.Configurator;
  errorText: string = "";
  CountToShow: number = 14;
  tooltipHtml: string;
  path = "AllLogss";
  config = {
    itemsPerPage: 10,
    currentPage: 1,
  };
  universalSub: Subscription;
  currentEntity: string;
  actionLevel: ActionLogActionLevel;
  isGlobalAdmin: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private navService: NavigationService,
    private spinner: NgxSpinnerService,
    private authenticationService: AuthenticationService,
    private actionLogService: ActionLogService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private env: EnvironmentService,
    private configEntityService: ConfigEntityService
  ) {
    this.isGlobalAdmin = this.authenticationService.currentUserValue.role === UserRoleNames.GlobalAdmin;
  }

  ngOnInit(): void {
    this.route.queryParams.pipe(take(1)).subscribe((params) => {
      this.selectedDataType = params["type"] || this.path;
    });
    this.shouldShowColumn =
      this.selectedDataType === "Deployment" ||
      this.selectedDataType === "application" ||
      this.selectedDataType === "License Server" ||
      this.selectedDataType === "AllLogs" ||
      this.selectedDataType === "Job" ||
      this.selectedDataType === "Node" ||
      this.selectedDataType === "Session" ||
      this.selectedDataType === "User" ||
      this.selectedDataType === "Storage";
    this.columnName = this.getColumnName();

    if (this.currentActiveEntityConfigurator) {
      this.navService.sendChildData("Logs");
    } else {
      this.navService.sendParentData("Logs");
    }
    this.navService.breadcrumbDeployment.subscribe((x) => {
      if (x == "All Nodes") {
        x = "All";
      }
      this.depName =
        x ||
        this.route.snapshot.params["deploymentName"] ||
        this.route.parent.snapshot.params["deploymentName"];
    });
    if (this.depName == "Sessions" || this.depName == "Session") {
      this.depName = "all";
    }
    if (!this.depName) {
      this.depName = "all";
    }
    this.currentLoggedUser =
      this.authenticationService.currentUserValue.username;
    this.spinner.show();
    this.showDelete =
      this.authenticationService.getRole() == UserRoleNames.JobOperator ||
      this.authenticationService.getRole() == UserRoleNames.Reader
        ? false
        : true;
    this.getLogsCount();

    this.universalSub = this.navService.breadcrumbEntity.subscribe((x) => {
      if (this.currentEntity != x) {
        this.currentEntity = x;
      }
    });

    if (this.currentEntity == Entities.Configurator) {
        
        this.configEntityService.sendActiveEntity("Activity Logs")
    }
  }

  loadActionLogsData(entries: number) {
    this.spinner.show();
    this.loadActionLogDataSub = this.actionLogService
      .getActionLogs(
        this.selectedDataType,
        this.depName,
        "all",
        this.actionFilterValue,
        this.actionLevelFilterValue,
        this.initiatorFilterValue,
        entries
      )
      .subscribe({
        next: (data: ActionLogsDataI) => {
          this.spinner.hide();
          if (data.actionLogsData == null) {
            if (this.actionLogs) this.actionLogs.length = 0;
            this.dataAvailable = false;
            this.errorText = "No action logs available";
            return;
          }
          this.errorText = "";
          this.actionLogs = <ActionLog[]>(
            JSON.parse(JSON.stringify(data.actionLogsData))
          );
          this.actionLogsCopy = <ActionLog[]>(
            JSON.parse(JSON.stringify(data.actionLogsData))
          );
          this.dataAvailable = true;
          this.spinner.hide();
          this.checkIfActionAvailableOnPage();
          this.arrangeActionFilters();
          this.sortByTime();
          //filter for dropdown of sessions workstation and initiator
          if (
            this.selectedDataType == "Sessions" &&
            this.actionEntityName != "all"
          ) {
            this.actionLogs = this.actionLogs?.filter(
              (nd) => nd.entityName == this.actionEntityName
            );
          }
          if (
            this.selectedDataType == "Sessions" &&
            this.initiatorFilterValue != "all"
          ) {
            this.actionLogs = this.actionLogs?.filter(
              (nd) => nd.initiator == this.initiatorFilterValue
            );
          }
        },
        error: (error) => {
          this.spinner.hide();
          this.dataAvailable = false;
        },
      });
  }

  arrangeActionFilters() {
    this.actionLogs.forEach((action: ActionLog) => {
      this.allActionTypes.push(action.action);
      this.allActionLevels.push(action.actionLevel);
      this.allInitiators.push(action.initiator);
      this.actionPaths.push(action.entityPath);
      if (action.entityName == "Not Allocated") {
        this.entityNames.push("Not Allocated");
      } else {
        this.entityNames.push(action.entityName);
      }
    });
    this.allActionTypes = [...new Set(this.allActionTypes)]?.sort();
    this.allActionLevels = [...new Set(this.allActionLevels)]?.sort();
    this.allInitiators = [...new Set(this.allInitiators)]?.sort();
    this.actionPaths = [...new Set(this.actionPaths)]?.sort();
    this.entityNames = [...new Set(this.entityNames)]?.sort();
  }

  checkIfActionAvailableOnPage() {
    while ((this.p - 1) * 14 > this.actionLogs.length) {
      this.p--;
    }
  }

  applyFilter() {
    this.spinner.show();
    this.loadActionLogsData(this.entries);
  }

  refreshComponent() {
    const url = this.router.url;
    const [path, queryParams] = url.split("?");

    // Fully decode the path
    const decodedPath = decodeURIComponent(path);

    // Navigate to home first
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      // Then navigate to the decoded path with query params
      this.router.navigate([decodedPath], {
        queryParams: this.parseQueryParams(queryParams),
      });
    });
  }

  private parseQueryParams(queryString: string): { [key: string]: string } {
    if (!queryString) return {};
    return queryString.split("&").reduce((params, param) => {
      const [key, value] = param.split("=");
      params[decodeURIComponent(key)] = decodeURIComponent(value);
      return params;
    }, {} as { [key: string]: string });
  }

  resetFilter() {
    this.actionFilterValue = "all";
    this.actionLevelFilterValue = 10;
    this.initiatorFilterValue = "all";
    this.actionPathFilterValue = "all";
    this.entityFilterValue = this.selectedDataType;
    this.actionEntityName = "all";
    this.sortDate = 0;
    this.filterText = "";
    if (this.selectedDataType.toLowerCase() == "session") {
      this.depName = "all";
    }
    this.loadActionLogsData(this.entries);
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.loadActionLogDataSub) this.loadActionLogDataSub.unsubscribe();
    this.spinner.hide();
  }

  sortByTime() {
    if (this.sortDate == 0) {
      this.actionLogs.sort(
        (a, b) =>
          new Date(b.actionTime).getTime() - new Date(a.actionTime).getTime()
      );
    }
    if (this.sortDate == 1) {
      this.actionLogs.sort(
        (b, a) =>
          new Date(b.actionTime).getTime() - new Date(a.actionTime).getTime()
      );
    }
    this.sortDate++;
    if (this.sortDate == 2) {
      this.sortDate = 0;
    }
  }

  onSelectAllCheckBox(event) {
    if (event.target.checked) {
      this.selectAll = true;
      if (!this.actionLogs) return;
      for (let i = 0; i < this.actionLogs.length; i++) {
        if (!this.selectedActionLogs.includes(this.actionLogs[i].actionLogId)) {
          this.selectedActionLogs.push(this.actionLogs[i].actionLogId);
        }
      }
    } else {
      this.selectedActionLogs = [];
      this.selectAll = false;
    }
  }

  onCheckboxSelect(event, actionTime) {
    if (event.target.checked) {
      if (!this.selectedActionLogs.includes(actionTime)) {
        this.selectedActionLogs.push(actionTime);
      }
      if (this.selectedActionLogs.length == this.actionLogs.length) {
        this.selectAll = true;
      }
    } else {
      let idx = this.selectedActionLogs.indexOf(actionTime);
      this.selectedActionLogs.splice(idx, 1);
      if (
        this.selectedActionLogs.length == 0 ||
        this.selectedActionLogs.length != this.actionLogs.length
      ) {
        this.selectAll = false;
      }
    }
  }

  deleteActionLog() {
    if (this.selectedActionLogs.length == 0) {
      this.snackBar.open("No action logs selected", "Ok", { duration: 5000 });
      return;
    }
    this.dialog
      .open(ConfirmDialogComponent, {
        autoFocus: false,
        disableClose: false,
        width: "25%",
        data: {
          titleMessage: "Delete Confirmation",
          bodyMessage: "Do you want to delete selected(" + this.selectedActionLogs.length + ") action log(s)?",
          cancelText: "Cancel",
          submitText: "Delete",
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.actionLogService
            .deleteActionLogs(this.depName, this.selectedActionLogs)
            .subscribe({
              next: (data: any) => {
                this.selectedActionLogs.length = 0;
                if (this.selectAll) this.selectAll = false;
                this.sortDate = 0;
                this.loadActionLogsData(this.entries);
                this.snackBar.open(data.actionMessage, "Ok", {
                  duration: 5000,
                });
              },
              error: (err) => {},
            });
        }
      });
  }

  getActionLevelName(level: number): string {
    return ActionLogActionLevel[level] || "Unknown";
  }

  async downloadActionLogs(downloadAllLogs?: boolean) {
    this.snackBar.open("Please wait while we are preparing download", "Ok", {
      duration: 5000,
    });

    // If user has selected specific logs, download only those
    if (this.selectedActionLogs.length > 0 && !downloadAllLogs) {
      const selectedLogs = this.actionLogsCopy.filter(log =>
        this.selectedActionLogs.includes(log.actionLogId)
      );

      // Remove isExpanded property from each log
      const logsWithoutExpanded = selectedLogs.map(log => {
        const { isExpanded, ...rest } = log;
        return rest;
      });

      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(logsWithoutExpanded);
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1"); 
      XLSX.writeFile(wb, this.depName + "_SelectedActionLogs.xlsx");
      return;
    }

    // If no logs are selected or user explicitly wants all logs
    if (downloadAllLogs) {
      await this.actionLogService
        .getActionLogs(
          this.selectedDataType,
          this.depName,
          "all",
          this.actionFilterValue,
          this.actionLevelFilterValue,
          this.initiatorFilterValue,
          this.totalLogsCount,
          true
        )
        .subscribe({
          next: (data: ActionLogsDataI) => {
            this.spinner.hide();

            if (data.actionLogsData == null) {
              if (this.actionLogs) this.actionLogs.length = 0;
              this.dataAvailable = false;
              return;
            }
            this.actionLogsToDownload = <ActionLog[]>(
              JSON.parse(JSON.stringify(data?.actionLogsData))
            );

            if (!this.actionLogsToDownload || this.actionLogsToDownload.length == 0) {
              this.snackBar.open("No action logs available", "Ok", {
                duration: 5000,
              });
              return;
            }

            const logsWithoutExpanded = this.actionLogsToDownload.map(log => {
              const { isExpanded, ...rest } = log;
              return rest;
            });

            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(logsWithoutExpanded);
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            XLSX.writeFile(wb, this.depName + "_AllActionLogs.xlsx");
          },
          error: (err) => {
            this.spinner.hide();
            if (this.actionLogsToDownload) this.actionLogsToDownload.length = 0;
          },
        });
    } else {
      // Download currently visible logs if no specific logs are selected
      if (!this.actionLogs || this.actionLogs.length == 0) {
        this.snackBar.open("No action logs available", "Ok", {
          duration: 5000,
        });
        return;
      }

      const logsWithoutExpanded = this.actionLogs.map(log => {
        const { isExpanded, ...rest } = log;
        return rest;
      });

      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(logsWithoutExpanded);
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, this.depName + "_CurrentActionLogs.xlsx");
    }
  }

  onSearch() {
    this.actionLogs = [...this.actionLogsCopy];
    if (this.filterText != "") {
      this.actionLogs = this.actionLogs.filter(
        (nd) =>
          nd.entityName.toLowerCase().includes(this.filterText.toLowerCase()) ||
          nd.action.toLowerCase().includes(this.filterText.toLowerCase())
      );
    }
    this.p = 1;
  }

  startRange: number = 1;
  loadLogsDataForRange(entry: number) {
    if (this.entries == this.defaultValueOfEntry) {
      this.startRange = 1;
    } else if (this.entries == this.totalLogsCount) {
      this.startRange =
        Number(
          Math.floor(this.totalLogsCount / this.defaultValueOfEntry) *
            this.defaultValueOfEntry
        ) + 1;
    } else {
      this.startRange = Number(this.entries - this.defaultValueOfEntry) + 1;
    }
    this.loadActionLogsData(entry);
  }

  paginationEntries(event) {
    this.entriesNumber = event.target.value;
  }

  showAllEntriesMethod() {
    if (this.entriesNumber > 0) {
      this.logsNumberToShow = this.entriesNumber;
      this.p = 0;
    }
  }

  toggleRowDetails(action: ActionLog, toggleValue) {
    this.actionLogs.find(
      (e) => e.actionLogId == action.actionLogId
    ).isExpanded = !toggleValue;
  }

  toggleFilters() {
    this.toShowFilter = !this.toShowFilter;
  }

  getLogsCount() {
    this.loadActionLogDataSub = this.actionLogService
      .getActionLogsCount(
        this.selectedDataType,
        this.depName,
        "all",
        this.actionFilterValue,
        this.actionLevelFilterValue,
        this.initiatorFilterValue
      )
      .subscribe({
        next: (data: any) => {
          this.logNumberEntries = data?.rangeCounts
            .split(",")
            .map((c) => Number(c));
          this.totalLogsCount =
            this.logNumberEntries[this.logNumberEntries.length - 1];
          this.defaultValueOfEntry = this.logNumberEntries[0];
          this.entries = this.logNumberEntries[0];

          if (this.logNumberEntries == this.defaultValueOfEntry) {
            this.startRange = 1;
          } else if (this.entries == this.totalLogsCount) {
            let lastEntry = Number(
              Math.floor(this.totalLogsCount / this.defaultValueOfEntry) *
                this.defaultValueOfEntry
            );
            this.startRange =
              lastEntry == this.totalLogsCount
                ? lastEntry - this.defaultValueOfEntry + 1
                : lastEntry + 1;
          } else {
            this.startRange =
              Number(this.entries - this.defaultValueOfEntry) + 1;
          }
          this.loadActionLogsData(this.entries);
        },
        error: (error: any) => {},
      });
  }

  getColumnName() {
    if (
      this.selectedDataType === "Job" ||
      this.selectedDataType === "Node" ||
      this.selectedDataType === "Session"
    ) {
      return "Deployment";
    } else if (this.selectedDataType === "User") {
      return "Administrator";
    } else {
      return "Container";
    }
  }
}
